module.exports = __webpack_public_path__ + "img/vesting-instrument.f9ec900d.jpg";